import { render, staticRenderFns } from "./StockProductDetailsView.vue?vue&type=template&id=a3813f20"
import script from "./StockProductDetailsView.vue?vue&type=script&lang=js"
export * from "./StockProductDetailsView.vue?vue&type=script&lang=js"
import style0 from "./StockProductDetailsView.vue?vue&type=style&index=0&id=a3813f20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports